import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScheduleList } from '../components/ScheduleList';

export const Lineup: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto pb-20">
      <h1 className="text-3xl font-bold p-4 text-primary sticky top-0 bg-background/95 backdrop-blur z-20">{t('pages.lineupTitle')}</h1>
      <ScheduleList />
    </div>
  );
};
